<template>
    <div class="padding-top-50 padding-bottom-50">
        <p class="back hover-pointer hover-yellow" @click="close">Назад</p>
        <div class="or-news-card flex-column column-space-between">
            <div class='title-container flex-row row-space-between row-ver-center'>
                <h2 class="title">{{news.title}}</h2>
                <p class="date">{{news.date}}</p>
            </div>
            <div v-html="text" class="content"></div>
            <p class="button hover-pointer hover-white" @click="close">Вернуться к новостям</p>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    props: {
        news: Object,
        scroll_top: Number,
    },
    computed: {
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.news.text, container: div});
            return div.innerHTML;
        }
    },
    mounted() {
        window.scrollTo(0,0);
    },
    unmounted() {
        window.scrollTo(0, this.scroll_top);
    },
    methods: {
        ...mapActions({convertText: 'convertText'}),
        close() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
    .back {
        font-size: 14px;
        line-height: 16px;
        color: #ffffff;
        text-align: left;
        margin-bottom: 50px;
    }
    .or-news-card {
        padding: 50px 35px;
        box-sizing: border-box;
        width: 1200px;
        background-color: #1e1e1e;
        border-radius: 8px;
    }
    .title-container {
        width: 1130px;
        margin-bottom: 30px;
    }
    .title {
        font-size: 20px;
        line-height: 23px;
        color: #EBB932;
    }
    .date {
        font-size: 14px;
        line-height: 16px;
        color: #666666;
    }
    .content {
        width: 980px;
        font-size: 14px;
        line-height: 24px;
        text-align: left;
        margin-bottom: 30px;
    }
    .button {
        width: 1130px;
        font-size: 14px;
        line-height: 16px;
        color: #EBB932;
        text-align: left;
    }
</style>